import React from 'react';
import './App.css'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/home/Home';
import Clubs from './pages/Clubs/Clubs';
import ClubProfile from './pages/Clubs/ClubProfile';
import PublicClubInvitePage from './pages/Clubs/PublicClubInvitePage';
import About from './pages/About/About';
import Register from './pages/Register/Register';
import Terms from './pages/Terms/Terms';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import PublicEventPage from './pages/Events/PublicEventPage';
import PublicListingPage from './pages/Marketplace/PublicListingPage';
import VenueMarketplaceHome from './pages/Marketplace/VenueMarketplaceHome';
import PublicPerkPage from './pages/Perks/PublicPerkPage';
import Dashboard from './pages/dashboard/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { UserProvider } from './UserContext';
import { useEffect } from 'react';
import { appConfig } from './config/appConfig';
import StandLaunch from './pages/stand/StandLaunch';
import StandCodeEntry from './pages/stand/StandCodeEntry';

function App() {
    useEffect(() => {
        document.title = appConfig.appName;

        const descriptionTag = document.querySelector('meta[name="description"]');
        if (descriptionTag) {
            descriptionTag.setAttribute('content', appConfig.messaging.metaDescription);
        }
    }, []);

    return (
        <UserProvider>
            <Router>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/About" element={<About />} />
                    <Route path="/Clubs" element={<Clubs />} />
                    <Route path="/clubs/:clubKey" element={<ClubProfile />} />
                    <Route path="/clubs/:clubKey/storefront" element={<VenueMarketplaceHome />} />
                    <Route path="/venues/invite/:token" element={<PublicClubInvitePage />} />
                    <Route path="/connect-perks" element={<Navigate to="/dashboard/connect-perks" replace />} />
                    <Route path="/Register" element={<Register />} />
                    <Route path="/Terms" element={<Terms />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/events/:token" element={<PublicEventPage />} />
                    <Route path="/marketplace/:token" element={<PublicListingPage />} />
                    <Route path="/perks/:token" element={<PublicPerkPage />} />
                    <Route path="/stand-access" element={
                        <ProtectedRoute>
                            <StandCodeEntry />
                        </ProtectedRoute>
                    } />
                    <Route path="/s/:standCode" element={
                        <ProtectedRoute>
                            <StandLaunch />
                        </ProtectedRoute>
                    } />
                    <Route path="/stand/:standId" element={<Navigate to="/stand-access" replace />} />
                    <Route path="/dashboard/*" element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Router>
        </UserProvider>
    );
}

export default App;
